import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceOverviewCard = ({ metrics }) => {
  const overviewItems = [
    {
      label: 'Department Performance Score',
      value: `${metrics?.departmentPerformanceScore || 0}%`,
      icon: 'TrendingUp',
      color: 'blue',
      trend: '+5.2%',
      trendUp: true
    },
    {
      label: 'Training Completion Rate',
      value: `${metrics?.trainingCompletionRate || 0}%`,
      icon: 'GraduationCap',
      color: 'emerald',
      trend: '+8.1%',
      trendUp: true
    },
    {
      label: 'Succession Readiness',
      value: `${metrics?.successionReadiness || 0}%`,
      icon: 'Users',
      color: 'purple',
      trend: '+3.5%',
      trendUp: true
    },
    {
      label: 'Development Budget Utilization',
      value: `K${((metrics?.developmentBudgetUtilization || 0) * 1000)?.toLocaleString()}`,
      icon: 'DollarSign',
      color: 'amber',
      trend: '-2.3%',
      trendUp: false
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'from-blue-500 to-blue-600 text-blue-600 bg-blue-50',
      emerald: 'from-emerald-500 to-emerald-600 text-emerald-600 bg-emerald-50',
      purple: 'from-purple-500 to-purple-600 text-purple-600 bg-purple-50',
      amber: 'from-amber-500 to-amber-600 text-amber-600 bg-amber-50'
    };
    return colors?.[color] || colors?.blue;
  };

  return (
    <div className="space-y-4">
      {overviewItems?.map((item, index) => {
        const colorClasses = getColorClasses(item?.color);
        const [gradientFrom, gradientTo, textColor, bgColor] = colorClasses?.split(' ');

        return (
          <div
            key={index}
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-5 hover:shadow-md transition-shadow"
          >
            <div className="flex items-start justify-between mb-3">
              <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${gradientFrom} ${gradientTo} flex items-center justify-center shadow-md`}>
                <Icon name={item?.icon} size={24} className="text-white" />
              </div>
              <div className={`flex items-center gap-1 px-2 py-1 rounded-lg ${
                item?.trendUp ? 'bg-emerald-50 text-emerald-700' : 'bg-red-50 text-red-700'
              }`}>
                <Icon name={item?.trendUp ? 'TrendingUp' : 'TrendingDown'} size={14} />
                <span className="text-xs font-semibold">{item?.trend}</span>
              </div>
            </div>
            <h3 className="text-sm font-medium text-slate-600 mb-2">{item?.label}</h3>
            <p className={`text-3xl font-bold ${textColor}`}>{item?.value}</p>
          </div>
        );
      })}
    </div>
  );
};

export default PerformanceOverviewCard;